import { render, staticRenderFns } from "./CarType.vue?vue&type=template&id=1a441ab8&"
import script from "./CarType.vue?vue&type=script&lang=js&"
export * from "./CarType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports